/** @jsxImportSource @emotion/react */
import { useEffect } from 'react';
import { css } from '@emotion/react';
import parse from 'parse-json';

import { hooks as commonHooks, types as commonTypes } from '@sitebuilder/common';
import {
    getTextSchemaProperties,
    getStyleSchemaProperties,
    getLayoutSchemaProperties,
} from '../utils';
import { themeAnnotationsStyles } from './Annotations.styles';

export interface AnnotationFilters {
    id?: string;
    textTargetId?: string;
    markerTargetId?: string;
    inUse?: boolean;
}

interface AnnotationsProps {
    filterBy?: string;
    setDiscalimer?: (disclaimer: string) => void;
    filters?: AnnotationFilters;
}

interface WidgetProperties extends commonTypes.WidgetPropertiesBase {
    typographyClass?: string;
    filterBy?: string;
    setDiscalimer?: (disclaimer: string) => void;
    filters?: AnnotationFilters;
}

export interface Widgetprops extends commonTypes.WidgetInstanceProps, AnnotationsProps {}

export const Annotations = (props: Widgetprops) => {
    const widgetProperties = commonHooks.useWidgetProperties<WidgetProperties>(
        props.widgetInstanceId
    );
    const { styles, filterBy, filters, setDiscalimer } = widgetProperties || props;

    const theme = props?.data?.themeSelected || props?.theme;

    let finalFilters: AnnotationFilters = {};

    if (filters) {
        (Object.keys(filters) as (keyof AnnotationFilters)[]).forEach((key) => {
            if (filters[key]) finalFilters = { ...finalFilters, [key]: filters[key] };
        });
    }

    const i18n = commonHooks.useLocalization();

    const { data } = props;
    let filterObject: any;

    try {
        filterObject = parse((filterBy as string) || '{}');
    } catch (error) {
        filterObject = {};
    }

    const annotator = commonHooks.useAnnotator();
    const html = annotator.getAnnotationsX(filterObject, finalFilters, data, i18n);

    useEffect(() => {
        if (html && setDiscalimer) {
            setDiscalimer(html);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    return (
        <>
            <div
                className={`section section--titled ${
                    widgetProperties?.typographyClass ? widgetProperties.typographyClass : ''
                }`}
                css={css`
                    ${!theme ? '' : themeAnnotationsStyles}${getTextSchemaProperties(
                        widgetProperties,
                        data?.colorSpace
                    )}${getStyleSchemaProperties(widgetProperties)}${getLayoutSchemaProperties(
                        widgetProperties
                    )}${styles || ''}
                `}
                dangerouslySetInnerHTML={{ __html: html }}
            />
            {/* force ui rerender */}
            <span style={{ display: 'none' }}>{html}</span>
        </>
    );
};

export default Annotations;
